const financialWellnessBlocks = document.querySelectorAll(".feature-financial-wellness");

financialWellnessBlocks.forEach(financialWellnessBlock => {
	const tabButtons = financialWellnessBlock.querySelectorAll(".js-tab-button");
	const tabs = financialWellnessBlock.querySelectorAll(".js-tab");
	const slideTrack = financialWellnessBlock.querySelector(".js-slide-track");
	const prevButton: null | HTMLButtonElement = financialWellnessBlock.querySelector(".js-prev-button");
	const nextButton: null | HTMLButtonElement = financialWellnessBlock.querySelector(".js-next-button");
	let slideTop: number = 0;

	moveSlideBullet(tabButtons[0] as HTMLElement);
	setSlide(0);
	if (tabButtons[0]) {
		tabButtons[0].classList.add('active');
	}

	function moveSlideBullet(activeElement: HTMLElement) {
		const parent = getParentElementWithClass(activeElement, "tab-header");
		const coordinates = {
			top: activeElement.offsetTop - parent.offsetTop,
			left: activeElement.offsetLeft - parent.offsetLeft,
			width: activeElement.offsetWidth,
		};
		slideTrack.setAttribute(
			"style",
			`--slide-top: ${coordinates.top.toString()}px; --slide-left: ${coordinates.left.toString()}px; --slide-width: ${coordinates.width.toString()}px`
		);
	}
	function setSlide(activeSlide: number | string = 0) {
		if (tabs[activeSlide]) {
			tabs[0].parentElement.classList.add("fadeOut");
			tabs.forEach((tab: HTMLElement) => {
				if (tab.dataset.tabId == activeSlide.toString()) {
					tab.classList.add("active");
				} else {
					tab.classList.remove("active");
				}
			});
			setTimeout(() => {
				tabs[0].parentElement.classList.remove("fadeOut");
			}, 200);
		}
		if (activeSlide == "0") {
			prevButton.disabled = true;
		} else if (activeSlide == tabs.length - 1) {
			nextButton.disabled = true;
		} else {
			prevButton.disabled = false;
			nextButton.disabled = false;
		}
	}

	tabButtons.forEach((button) => {
		button.addEventListener("click", (e) => {
			const activeElement = e.target as HTMLElement;

			if (!activeElement.classList.contains("active")) {
				tabButtons.forEach((button) => {
					button.classList.remove("active");
				});
				activeElement.classList.add("active");
				moveSlideBullet(activeElement);
				setSlide(activeElement.dataset.tabId);
			}
		});
	});
	nextButton.addEventListener("click", () => {
		const activeSlide: null | HTMLElement = financialWellnessBlock.querySelector(".js-tab.active");
		setSlide(Number(activeSlide.dataset.tabId) + 1);
	});
	prevButton.addEventListener("click", () => {
		const activeSlide: null | HTMLElement = financialWellnessBlock.querySelector(".js-tab.active");
		setSlide(Number(activeSlide.dataset.tabId) - 1);
	});
	window.addEventListener("resize", (e) => {
		const activeElement: HTMLElement = financialWellnessBlock.querySelector(".js-tab-button.active");
		moveSlideBullet(activeElement);
	});
})
